<!--
 * @Description:销售计划新增/编辑弹出层
 * @Author: Tina
 * @Date: 2023-01-01 11:39:31
 * @LastEditors: Tina
 * @LastEditTime: 2023-02-08 07:44:32
 -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1000px"
      @close="$emit('update:show',false)">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="模板名称" prop="name">
              <el-input class="inputbox" v-model="form.name" placeholder="请输入计划名称"></el-input><!-- :disabled="isEdit" -->
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 模板 -->
        <div class="template-box bod">
          <div class="flex-between">
            <div class="template-box-item bd_r"> <span class="red">*</span> 客户等级</div>
            <div class="template-box-item bd_r w120"> <span class="red">*</span> 计划销售占比</div>
            <div class="template-box-item bd_r w120"> <span class="red">*</span> 下单时间</div>
            <div class="template-box-item bd_r w120"> <span class="red">*</span> 抢单时间</div>
            <div class="template-box-item bd_r w220"> <span class="red">*</span> 计划规则</div>
            <div class="template-box-item"> <span class="red">*</span> 备注</div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h100">
              <!-- <el-form-item label="" prop="level1Name"> -->
                <el-input class="inputboxsmall" v-model="form.level1Name" placeholder="请输入名称"></el-input>
              <!-- </el-form-item> -->
            </div>
            <div class="template-box-item bd_r w120 h100"><el-input class="inputboxmini" v-model="form.level1SaleProport"></el-input> %</div>
            <div class="template-box-item bd_r w120 h100"><el-input class="inputboxmini" v-model="form.level1PlaceOrderTime"></el-input> 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h50 w120">前 <el-input class="inputboxmini" v-model="form.level1SnatchOrderTimeStart" size="mini"></el-input> 分钟</div>
              <div class="template-box-item h50 w120">后 <el-input class="inputboxmini" v-model="form.level1SnatchOrderTimeEnd" size="mini"></el-input> 分钟</div>
            </div>
            <div class="bd_r w220 fs12">
              <div class="template-box-item bd_b h50 w220">当前客户等级的单个限量 <el-input class="inputboxmini" v-model="form.level1PlanningRules1" size="mini"></el-input> %</div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h50">最小计划量 <el-input class="inputboxmini" v-model="form.level1PlanningQuantity" size="mini"></el-input> 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h130"><el-input class="inputboxsmall" v-model="form.level2Name" placeholder="请输入名称"></el-input></div>
            <div class="template-box-item bd_r w120 h130"><el-input class="inputboxmini" v-model="form.level2SaleProport"></el-input> %</div>
            <div class="template-box-item bd_r w120 h130"><el-input class="inputboxmini" v-model="form.level2PlaceOrderTime"></el-input> 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h80 w120" style="padding-top:24px;">前 <el-input class="inputboxmini" v-model="form.level2SnatchOrderTimeStart" size="mini"></el-input> 分钟</div>
              <div class="template-box-item h50 w120">后 <el-input class="inputboxmini" v-model="form.level2SnatchOrderTimeEnd" size="mini"></el-input> 分钟</div>
            </div>
            <div class="bd_r w220 fs12">
              <div class="template-box-item bd_b h80 w220">
                <div>上一等级客户的单个限量 <el-input class="inputboxmini" v-model="form.level2PlanningRules1" size="mini"></el-input> % ✖ <el-input class="inputboxmini" v-model="form.level2PlanningRules2" size="mini"></el-input> %</div>
                <div style="margin-top:5px;">当前客户等级的单个限量 <el-input class="inputboxmini" v-model="form.level2PlanningRules3" size="mini"></el-input> % ✖ <el-input class="inputboxmini" v-model="form.level2PlanningRules4" size="mini"></el-input> %</div>
              </div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">上一等级及当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h80" style="padding-top:24px;">最小计划量 <el-input class="inputboxmini" v-model="form.level2PlanningQuantity" size="mini"></el-input> 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r h130"><el-input class="inputboxsmall" v-model="form.level3Name" placeholder="请输入名称"></el-input></div>
            <div class="template-box-item bd_r w120 h130"><el-input class="inputboxmini" v-model="form.level3SaleProport"></el-input> %</div>
            <div class="template-box-item bd_r w120 h130"><el-input class="inputboxmini" v-model="form.level3PlaceOrderTime"></el-input> 分钟</div>
            <div class="bd_r w120">
              <div class="template-box-item bd_b h80 w120" style="padding-top:24px;">前 <el-input class="inputboxmini" v-model="form.level3SnatchOrderTimeStart" size="mini"></el-input> 分钟</div>
              <div class="template-box-item h50 w120">后 <el-input class="inputboxmini" v-model="form.level3SnatchOrderTimeEnd" size="mini"></el-input> 分钟</div>
            </div>
            <div class="bd_r w220 fs12">
              <div class="template-box-item bd_b h80 w220">
                <div>以上等级客户的单个限量 <el-input class="inputboxmini" v-model="form.level3PlanningRules1" size="mini"></el-input> % ✖ <el-input class="inputboxmini" v-model="form.level3PlanningRules2" size="mini"></el-input> %</div>
                <div style="margin-top:5px;">当前客户等级的单个限量 <el-input class="inputboxmini" v-model="form.level3PlanningRules3" size="mini"></el-input> % ✖ <el-input class="inputboxmini" v-model="form.level3PlanningRules4" size="mini"></el-input> %</div>
              </div>
              <div class="template-box-item h50 w220" style="padding-top:16px;">以上等级及当前客户等级的单个限量不限制</div>
            </div>
            <div class="">
              <div class="template-box-item bd_b h80" style="padding-top:24px;">最小计划量 <el-input class="inputboxmini" v-model="form.level3PlanningQuantity" size="mini"></el-input> 吨</div>
              <div class="template-box-item h50">/</div>
            </div>
          </div>
          <div class="flex-between bd_t">
            <div class="template-box-item bd_r">交易客户</div>
            <div class="template-box-item bd_r w120"><el-input class="inputboxmini" v-model="form.level4SaleProport"></el-input> %</div>
            <div class="template-box-item bd_r w120">/</div>
            <div class="template-box-item bd_r w120">/</div>
            <div class="template-box-item bd_r w220">/</div>
            <div class="template-box-item bd_r">/</div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {
        name: '',
        level1Name: '战略客户',
        level2Name: '稳定客户',
        level3Name: '潜力客户'
      },
      rules: {
        name: [{ required: true, message: '请输入模板名称' }],
        level1Name: [{ required: true, message: '请输入客户等级名称' }]
      }
    }
  },
  computed: {
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    },
    title () {
      return this.isEdit ? '编辑' : '新增'
    }
  },
  methods: {
    ...mapActions(['addSalePlanManage', 'editSalePlanManage', 'getSalePlanManageList']),
    // 提交
    submit () {
      this.$refs.form.validate(val => {
        if (val) {
          console.log(this.form)
          if (!this.form.level1Name || !this.form.level2Name || !this.form.level3Name) {
            return this.$message.error(`请填写客户等级`)
          }
          let object = {
            // 'level1Name': '客户等级',
            // 'level2Name': '客户等级',
            // 'level3Name': '客户等级',
            'level1SaleProport': '计划销售占比',
            'level2SaleProport': '计划销售占比',
            'level3SaleProport': '计划销售占比',
            'level4SaleProport': '计划销售占比',
            'level1PlaceOrderTime': '下单时间',
            'level2PlaceOrderTime': '下单时间',
            'level3PlaceOrderTime': '下单时间',
            'level1SnatchOrderTimeStart': '抢单时间',
            'level2SnatchOrderTimeStart': '抢单时间',
            'level3SnatchOrderTimeStart': '抢单时间',
            'level1SnatchOrderTimeEnd': '抢单时间',
            'level2SnatchOrderTimeEnd': '抢单时间',
            'level3SnatchOrderTimeEnd': '抢单时间',
            'level1PlanningRules1': '计划规则',
            'level2PlanningRules1': '计划规则',
            'level2PlanningRules2': '计划规则',
            'level2PlanningRules3': '计划规则',
            'level2PlanningRules4': '计划规则',
            'level3PlanningRules1': '计划规则',
            'level3PlanningRules2': '计划规则',
            'level3PlanningRules3': '计划规则',
            'level3PlanningRules4': '计划规则',
            'level1PlanningQuantity': '最小计划量',
            'level2PlanningQuantity': '最小计划量',
            'level3PlanningQuantity': '最小计划量'
          }
          // 28个字段校验
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key)) {
              const element = object[key]
              if (!this.form[key]) {
                return this.$message.error(`请填写${element}`)
              }
              if (isNaN(Number(this.form[key]))) {
                return this.$message.error(`${element}的值只能输入数字`)
              }
            }
          }
          let action = this.isEdit ? this.editSalePlanManage : this.addSalePlanManage
          action({ ...this.form, level4Name: '交易客户', level1PlanningRules2: '' }).then(() => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getSalePlanManageList()
            this.visible = false
          })
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        const { id } = this.info
        this.form = this.isEdit ? {
          id,
          ...this.info
        } : {
          name: ''
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner{
  padding: 0 4px;
}
.inputbox{
  width: 200px;
}
.inputboxsmall{
  width: 140px;
}
.inputboxmini{
  width: 40px;
}
.h50{
  height: 50px;
}
.h80{
  height: 80px;
}
.h100{
  height: 100px;
  padding-top:32px!important;
  // display: flex;
  // text-align: center;
  // align-items: center;
}
.h130{
  height: 130px;
  padding-top:52px!important;
}
.w120{
  width: 120px!important;
}
.w220{
  width: 280px!important;
}
.fs12{
  font-size: 12px;
}
.flex-between{
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.bod {border: 1px solid #ddd;}
.bd_t {border-top: 1px solid #ddd;}
.bd_b {border-bottom: 1px solid #ddd;}
.bd_r {border-right: 1px solid #ddd;}
.template-box{
  .template-box-item{
    width: 160px;
    padding: 10px 6px;
    text-align: center;
    flex-shrink: 0;
    .red{
      color: #f56c6c;
    }
  }
}
</style>
